export const config = {
  propsName: 'renderProps',
  name: 'SpSelect',
  type: 'formTmpsConfig',
  icon: 'el-icon-takeaway-box',
  cnName: '下拉框',
  base: {
    title: '下拉框',
    //subtitle: 'SpSelect_subtitle',
    padded: true,
    flex: '1',
    margin: [0, 0, 0, 0],
    selectVal: {
      addOptions: []
    }
  },
  props: [
    // {
    //   type: () => import('@/weappTmps/comps/flex/index.vue'),
    //   cmpPath: '/comps/flex/index.vue',
    //   key: 'flex',
    //   bind: {
    //     label: '排列方式'
    //   },
    //   on: {},
    //   value: null
    // },
    {
      type: () => import('@/weappTmps/comps/margin/index.vue'),
      cmpPath: '/comps/margin/index.vue',
      key: 'margin',
      bind: {
        label: '边距'
      },
      on: {},
      value: null
    },
    {
      type: 'el-input',
      key: 'title',
      bind: {
        label: '标题名称',
        placeholder: '请输入标题名称'
      },
      value: ''
    },
    {
      type: 'el-input',
      key: 'placeholder',
      bind: {
        label: '提示内容',
        placeholder: '请输入提示内容'
      },
      value: ''
    },
    {
      type: 'el-switch',
      key: 'required',
      bind: {
        label: '是否必填'
      },
      value: false
    },
    {
      type: () => import('@/weappTmps/comps/addOption/index.vue'),
      cmpPath: '/comps/addOptions/index.vue',
      key: 'selectVal',
      bind: {
        label: ''
      },
      value: {
        addOptions: []
      }
    }
    // {
    //   render: (h) => {
    //     return (
    //       <div class='avatar-wrap'>
    //         <div class='avatar-icon'>test render</div>
    //         <div class='avatar-info'>
    //           <div class='name'>item_name </div>
    //         </div>
    //       </div>
    //     )
    //   },
    //   key: 'test2',
    //   bind: {
    //     label: 'render'
    //   },
    //   value: null
    // }
    // {
    //   // type: () => import('./comps/xxxx'),
    //   key: '',
    //   value: []
    // },
    // {
    //   type: 'btns',

    // }
  ]
}
